import React, { useState, useEffect, useRef } from 'react';
import contactBanner from '../images/contact-banner.jpg';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  
  const bannerLeftRef = useRef(null);
  const bannerRightRef = useRef(null);
  const bannerContainerRef = useRef(null);

  useEffect(() => {
    const matchHeights = () => {
      if (bannerLeftRef.current && bannerRightRef.current && bannerContainerRef.current) {
        const rightHeight = bannerRightRef.current.offsetHeight;
        const leftHeight = bannerLeftRef.current.offsetHeight;
        const maxHeight = Math.max(rightHeight, leftHeight);
        
        if (maxHeight > 0) {
          bannerContainerRef.current.style.minHeight = `${maxHeight}px`;
          bannerLeftRef.current.style.minHeight = `${maxHeight}px`;
        }
      }
    };

    matchHeights();
    window.addEventListener('resize', matchHeights);
    
    return () => {
      window.removeEventListener('resize', matchHeights);
    };
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    }, 2000);
  };

  return (
    <div className="contact-page">
      {/* Banner Section */}
      <section className="contact-banner">
        <div className="contact-banner-container" ref={bannerContainerRef}>
          <div className="contact-banner-left" ref={bannerLeftRef}>
            <div className="contact-banner-image" style={{ backgroundImage: `url(${contactBanner})` }}>
              <div className="contact-image-overlay">
                <h1 className="contact-banner-title">CONTACT US</h1>
              </div>
            </div>
          </div>
          <div className="contact-banner-right" ref={bannerRightRef}>
            <div className="contact-banner-content">
              <h2 className="contact-banner-subtitle">GET IN TOUCH WITH US FOR BEST ADVICE AND SERVICE OFFERINGS ON LOAN PRODUCTS.</h2>
              <p className="contact-banner-description">
                At Ampire Finance, we're dedicated to helping you achieve your financial requirements. Whether you have questions about our services, need assistance with your requirement, or want to provide feedback, our team is here for you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="contact-section">
        <div className="contact-wrapper">
          {/* Main Heading */}
          <div className="main-heading">
            <h2 className="section-title">GET IN TOUCH</h2>
            <div className="title-line"></div>
          </div>

          {/* Two Column Layout */}
          <div className="contact-grid">
            {/* Left Column - Contact Info */}
            <div className="contact-left">
              <div className="contact-info">
                <div className="info-card">
                  <div className="info-icon-wrapper">
                    <span className="info-icon">📍</span>
                  </div>
                  <div className="info-details">
                    <h3 className="info-label">REGISTERED OFFICE</h3>
                    <p className="info-text">
                      Sf-8, Narayan Chambers, B/H Patang Hotel,<br />
                      Ashram Road, Ahmedabad-380009
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon-wrapper">
                    <span className="info-icon">📞</span>
                  </div>
                  <div className="info-details">
                    <h3 className="info-label">PHONE</h3>
                    <p className="info-text">+91-8655661095</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon-wrapper">
                    <span className="info-icon">✉️</span>
                  </div>
                  <div className="info-details">
                    <h3 className="info-label">EMAIL</h3>
                    <p className="info-text">support@ampirefinance.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Map */}
            <div className="contact-right">
              <div className="map-section">
                <div className="map-wrapper">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.925583459289!2d72.56970747555938!3d23.026504416180895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8457400385a5%3A0x3e26cfeffb49842d!2sPatang%20Re-Evolve!5e0!3m2!1sen!2sin!4v1764927861998!5m2!1sen!2sin" 
                    width="100%" 
                    height="450" 
                    style={{border:0}} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ampire Finance Location"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

          {/* Form Section - Full Width Below Both Columns */}
          <div className="form-section-full">
            <h2 className="form-title">LEAVE A MESSAGE</h2>
            <p className="form-description">
              Reach out to us for inquiries, support, or to learn more about our services!
            </p>
            
            <div className="form-container">
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="input-group">
                  <label htmlFor="name">NAME</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name"
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="email">EMAIL</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    required
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="message">MESSAGE</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className={`submit-btn ${isSubmitting ? 'loading' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'SEND'}
                </button>

                {submitStatus === 'success' && (
                  <div className="success-msg">
                    ✅ Thank you for your message! We'll get back to you soon.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-wrapper">
          <h2 className="faq-heading">Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-card">
              <h3>How quickly can I get a loan approved?</h3>
              <p>Our loan approval process typically takes 24-48 hours for personal loans and 3-5 business days for home and business loans, subject to document verification.</p>
            </div>
            <div className="faq-card">
              <h3>What documents do I need to apply?</h3>
              <p>Basic documents include PAN card, Aadhaar card, income proof, bank statements, and address proof. Specific requirements may vary based on loan type.</p>
            </div>
            <div className="faq-card">
              <h3>What are the minimum eligibility criteria?</h3>
              <p>Generally, you need to be 21-65 years old, have a minimum monthly income of ₹15,000, and a good credit score. Criteria may vary by loan product.</p>
            </div>
            <div className="faq-card">
              <h3>Can I prepay my loan?</h3>
              <p>Yes, we offer flexible prepayment options with minimal charges. Early repayment can help you save on interest costs.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
